import { gql } from '@apollo/client';

const GET_DROP_OFF_LOCATIONS_QUERY = gql`
  query DropoffLocationSearch($dropoffLocationsInput: DropoffLocationsInput) {
    dropoffLocationSearch(dropoffLocationsInput: $dropoffLocationsInput) {
      addressGeoCoordinates {
        latitude
        longitude
      }
      dropoffLocations {
        id
        name
        distance
        locationId
        geoPosition {
          latitude
          longitude
        }
        providerType
        operatingHours {
          dayOfWeek
          closeHours
          openHours
        }
        address {
          city
          postalCode
          state
          street
        }
      }
      postalCode
      nearMe
      qrcodeEnabled
      cityStateText
      findStoreText
      locationText
      youText
      noStoresFoundNearText
      pleaseTryDifferentLocationText
      locationServicesBlockedText
      headerTextKey
      subTitleTextKey
    }
  }
`;

export default GET_DROP_OFF_LOCATIONS_QUERY;
